import { VmImageIcon } from "@/modules/compute/VmImageIcon.tsx";
import { imagesByOsNameAtom } from "@/modules/compute/vmImagesQuery.ts";
import type { BaseProps } from "@/utils/baseProps.ts";
import { useAtomValue } from "jotai/react";

export function OsImageIcon({ os_name, ...props }: { os_name: string } & BaseProps) {
    const imagesByOsName = useAtomValue(imagesByOsNameAtom);
    const image = imagesByOsName?.data?.get(os_name);
    return <VmImageIcon image={image} {...props} />;
}
